const randInt = (min, max) => {
  const localMin = Math.ceil(min);
  const localMax = Math.floor(max);
  return Math.floor(Math.random() * (localMax - localMin)) + localMin;
};

export default randInt;
